import { Weather, Forecast } from './classes/weather';
import { Title } from '@angular/platform-browser';
import { Component, OnInit, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LocalStorageService } from './Services/local-storage.service';
import {
  SwiperComponent, SwiperDirective, SwiperConfigInterface,
  SwiperScrollbarInterface, SwiperPaginationInterface
} from 'ngx-swiper-wrapper';
import { EventEmitterService } from './event-emitter.service';
import { Observable, interval, Subscription } from 'rxjs';
import { Time } from '@angular/common';
import { Router } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { WeatherData } from './classes/weather-data';
import { CityInformation } from './classes/city-information';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';



export class LocalSelectedCity {

  
  public selectedCityName: string;
  public selectedCity: number;
}
export class LocalStorageInformation {

  public weather: WeatherData;
}


export class WeatherForCity {

  City: string;
  Temperature: string;
}

function normalizeCity(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],

  providers: [Location, { provide: LocationStrategy, useClass: PathLocationStrategy }],
})
export class AppComponent implements OnInit {

  

  config: SwiperConfigInterface = {
    slidesPerView: 1,
    spaceBetween: 0

  };

  private updateSubscription: Subscription;
  weathers: WeatherForCity[];
  cityInformations: CityInformation[];
  currentCity: string;

  @ViewChild(SwiperDirective, { static: true }) directiveRef: SwiperDirective;

  constructor(private eventEmitterService: EventEmitterService,
              private titleService: Title,
              private localStorageService: LocalStorageService,
              private location: Location,
              private analytics: AngularFireAnalytics,
              @Inject(PLATFORM_ID) private platformId: any) {

    if (isPlatformBrowser(this.platformId)) {
      this.analytics.logEvent('app_open', { component: 'AppComponent' });
    }

  }

  ngOnInit() {
      this.cityInformations = this.getCityInformation();

      if (this.eventEmitterService.subsVar === undefined) {
        this.eventEmitterService.subsVar = this.eventEmitterService.invokeFirstComponentFunction.subscribe
          ((name: number) => { this.firstFunction(name); });
        this.eventEmitterService.subsVar = this.eventEmitterService.invokeWeatherChangedFunction.subscribe
          (({ weather, city }) => { this.secondFunction(weather, city); });
      }

      // Handle routing after a short delay to let Swiper initialize
      setTimeout(() => this.handleRouting(), 100);

      // change title (only in browser)
      if (isPlatformBrowser(this.platformId)) {
        this.updateSubscription = interval(3000).subscribe((val) => { this.updateTitle(); });
      }
  }

  private handleRouting(): void {
    const path = this.location.path(true);
    // Check if URL has a city path
    if (path !== undefined && path !== '' && path !== '/') {
      const cityName = decodeURIComponent(path.replace(/^\//, ''));
      const idx = this.cityInformations.findIndex(c => normalizeCity(c.CityName) === normalizeCity(cityName));
      if (idx >= 0) {
        this.directiveRef.setIndex(idx);
        // store selection
        const selectedCity = new LocalSelectedCity();
        selectedCity.selectedCity = idx;
        selectedCity.selectedCityName = this.cityInformations[idx].CityName;
        this.localStorageService.storeSelectedCityToLocalStorage(selectedCity);
        return;
      }
    }
    
    // No valid path, use localStorage or default
    const localstorageData = this.localStorageService.getStoredSelectedCity();
    if (localstorageData !== undefined && localstorageData != null && localstorageData.selectedCity !== undefined) {
      this.directiveRef.setIndex(localstorageData.selectedCity);
    }
  }

  private getCityInformation(): CityInformation[]
  {
    return [
      {CityID: '101118', CityName: 'Tampere', yrnoLocation: 'altitude=90&lat=61.466863&lon=23.641649', dataHash: '/tampere'},
      {CityID: '100971', CityName: 'Helsinki', yrnoLocation: 'altitude=7&lat=60.169856&lon=24.938379', dataHash: '/helsinki'},
      {CityID: '101786', CityName: 'Oulu', yrnoLocation: 'altitude=1&lat=65.012089&lon=25.465077', dataHash: '/oulu'},
      {CityID: '101572', CityName: 'Kuopio', yrnoLocation: 'altitude=90&lat=62.89797&lon=27.678172', dataHash: '/kuopio'},
      { CityID: '137208', CityName: 'Jyväskylä', yrnoLocation: 'altitude=95&lat=62.242603&lon=25.747257', dataHash: '/jyvaskyla'},
      {CityID: '101485', CityName: 'Vaasa', yrnoLocation: 'altitude=5&lat=63.095089&lon=21.616456', dataHash: '/vaasa'},
      {CityID: '100968', CityName: 'Vantaa', yrnoLocation: 'altitude=17&lat=60.293352&lon=25.037769', dataHash: '/vantaa'},
      {CityID: '874863', CityName: 'Espoo', yrnoLocation: 'altitude=10&lat=60.205491&lon=24.6559', dataHash: '/espoo'},
      {CityID: '104796', CityName: 'Lahti', yrnoLocation: 'altitude=103&lat=60.982675&lon=25.66121', dataHash: '/lahti'},
      { CityID: '101044', CityName: 'Pori', yrnoLocation: 'altitude=4&lat=61.485139&lon=21.797418', dataHash: '/pori'},
      { CityID: '101928', CityName: 'Rovaniemi', yrnoLocation: 'altitude=93&lat=66.503948&lon=25.729391', dataHash: '/rovaniemi'},
      {CityID: '101150', CityName: 'Hämeenlinna', yrnoLocation: 'altitude=82&lat=60.992879&lon=24.459024', dataHash: '/hameenlinna'},
      {CityID: '101237', CityName: 'Lappeenranta', yrnoLocation: 'altitude=102&lat=61.054993&lon=28.189663', dataHash: '/lappeenranta'},
    ];

  }

  private getToijala(): CityInformation[]
  {
    return [
      {CityID: '101151', CityName: 'Toijala', yrnoLocation: 'altitude=45&lat=61.165462&lon=23.867264', dataHash: '#Toijala'},

    ];

  }

  firstFunction(name: number) {
    // console.log('firstFunction:' + name);
    this.directiveRef.setIndex(name);

  }


  secondFunction(weather: string, city: string) {


    if (this.weathers == null ||
      this.weathers === undefined) {
      this.weathers = [];
    }

    const result = this.weathers.find(obj => {
      return (obj.City === city);
    });

    if (result !== undefined) {
      result.Temperature = weather;
    } else {
      const temp = new WeatherForCity();
      temp.City = city;
      temp.Temperature = weather;
      this.weathers.push(temp);
    }


  }



  public onIndexChange(index: number) {

    const cityname = this.cityInformations[index].CityName;
    this.currentCity = cityname;
    //console.log('onIndexChange: ' + cityname);

    const selectedCity = new LocalSelectedCity();
    selectedCity.selectedCity = index;
    selectedCity.selectedCityName = cityname;
    this.localStorageService.storeSelectedCityToLocalStorage(selectedCity);

    // Update URL when swiping
    this.location.go('/' + normalizeCity(cityname));

    // EASTER EGG!!!
    // Store the current index and if correct sequence is found, change the city
    if (this.localStorageService.StoreSwipeHistory(index))
    {
      this.weathers = [] as WeatherForCity[];
      this.cityInformations = this.getToijala();
      this.currentCity = this.cityInformations[0].CityName;
      this.directiveRef.setIndex(0);
      this.directiveRef.update();
      // this.directiveRef.ref


    }

  }

  updateTitle() {

    if (this.weathers !== undefined && this.weathers != null && this.weathers.length > 0) {

      const item = this.weathers[Math.floor(Math.random() * this.weathers.length)];
      this.setTitle(item.City + ' ' + item.Temperature + '\u2103');
    }
  }

  setTitle(name: string) {
    this.titleService.setTitle(name);
  }





}
